import React from "react";
import { useDrag } from "react-dnd";
import { Badge, Card, CardBody } from "reactstrap";
import {
  QuestionDifficulty,
  QuestionLevel,
  QuestionTopic,
  questionTypeMap,
  questionTypePicMap,
} from "../../constants/QuestionsBankConstants";
import { format } from "date-fns";

const DraggableCard = ({
  question,
  selectedCardId,
  setSelectedCardId,
  setIsNewQuestion,
}) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "CARD",
    item: {
      id: question.id,
      questionTitle: question.questionTitle,
      topic: question.topic,
      difficulty: question.difficulty,
      level: question.level,
      answer:
        question.answers[0]?.Options || "There are no question Options set!",
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  const handleCardClick = (id) => {
    setSelectedCardId(id);
    setIsNewQuestion(false);
  };

  return (
    <Card
      innerRef={drag}
      key={question.id}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "move",
        borderColor: selectedCardId === question.id ? "#3F88E4" : "#EAECF0",
        borderWidth: "2px",
        borderStyle: "solid",
      }}
      onClick={() => handleCardClick(question.id)}
    >
      <CardBody>
        <div className="d-flex justify-content-start align-items-center gap-1 mb-2">
          <Badge color={QuestionTopic[question.topic]}>{question.topic}</Badge>
          <Badge color={QuestionLevel[question.level]}>{question.level}</Badge>
          <Badge color={QuestionDifficulty[question.difficulty]}>
            {question.difficulty}
          </Badge>
        </div>
        <h5>{question.questionTitle}</h5>
        <div
          style={{ fontSize: "12px" }}
          className="d-flex flex-row flex-wrap align-items-baseline gap-1"
        >
          <div className="d-flex flex-row align-items-baseline">
            <span
              style={{ fontSize: "12px" }}
              className={`d-flex align-items-center justify-content-center ${
                questionTypePicMap[question.questiontype]
              }`}
            ></span>
            <span>{questionTypeMap[question.questiontype]}</span>
          </div>

          <span>|</span>

          <div className="d-flex flex-row align-items-center">
            <span
              style={{ fontSize: "12px" }}
              className="d-flex align-items-center justify-content-center mdi mdi-calendar-blank-outline"
            ></span>
            {/* <span> {formatDate(question.createdAt)}</span> */}
            <span> {format(new Date(question.createdAt), "MMM dd, yyy")}</span>
          </div>

          <span>|</span>

          <div className="d-flex flex-row align-items-baseline">
            <span
              style={{ fontSize: "12px" }}
              className="d-flex align-items-center justify-content-center mdi mdi-account-edit-outline"
            ></span>
            <span>{question.name}</span>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default DraggableCard;
